export default {
  "discover_your": "जानिए अपना",
  "ascendant": "लग्न",
  "rising_sign_analysis": "लग्न राशि विश्लेषण",
  "ascendant_description": "यह आपके व्यक्तित्व, रूप-रंग और जीवन पथ को आकार देता है, जबकि चंद्र और सूर्य राशि समय-समय पर भविष्यवाणियों का मार्गदर्शन करती हैं।",
  "exact_time_critical_for_ascendant": "सटीक जन्म समय, सही लग्न गणना के लिए आवश्यक है।",
  "location_essential_for_ascendant": "सटीक स्थान, आपकी लग्न राशि निर्धारित करने के लिए जरूरी है।",
  "complete_ascendant_analysis": "पूर्ण लग्न विश्लेषण",
  "rising_sign_identification": "लग्न राशि की पहचान",
  "personality_traits_analysis": "व्यक्तित्व गुणों का विश्लेषण", 
  "first_impression_insights": "पहली छाप के बारे में जानकारी",
  "life_path_guidance": "जीवन पथ मार्गदर्शन",
  "focused_ascendant_analysis_note": "आपकी लग्न राशि और उससे जुड़े गुणों पर केंद्रित विशेष विश्लेषण।",
  "pay_and_generate_analysis": "भुगतान करें और विश्लेषण प्राप्त करें",
  "your_rising_sign_detailed": "आपकी लग्न राशि का विस्तृत विवरण",
  "personality_mask_analysis": "व्यक्तित्व का बाहरी आवरण और प्रस्तुति का विश्लेषण",
  "appearance_and_style_insights": "रूप-रंग और स्टाइल से जुड़ी जानकारी",
  "life_approach_patterns": "जीवन दृष्टिकोण और व्यवहारिक पैटर्न",
  "sample_ascendant_analysis": "उदाहरण लग्न विश्लेषण",
  "sample_ascendant_description": "यह आपके व्यक्तिगत लग्न रिपोर्ट का एक उदाहरण है, जिसमें विस्तृत जानकारियां दी गई हैं।",
  "rising_signs": "लग्न राशियाँ",
  "aries_rising": "मेष लग्न",
  "taurus_rising": "वृषभ लग्न",
  "gemini_rising": "मिथुन लग्न",
  "cancer_rising": "कर्क लग्न",
  "leo_rising": "सिंह लग्न",
  "virgo_rising": "कन्या लग्न",
  "ascendant_analysis_processing": "आपका लग्न विश्लेषण हमारे विशेषज्ञ ज्योतिषियों द्वारा तैयार किया जा रहा है।",
  "detailed_ascendant_report_pdf": "विस्तृत लग्न रिपोर्ट (PDF प्रारूप)",
  "rising_sign_characteristics": "लग्न राशि के गुण और विशेषताएं",
  "personality_presentation_insights": "व्यक्तित्व प्रस्तुति संबंधी जानकारी",
  "first_impression_analysis": "पहली छाप और सामाजिक व्यक्तित्व का विश्लेषण",
  "life_approach_guidance": "जीवन दृष्टिकोण और व्यवहार मार्गदर्शन",
  "your_ascendant_analysis_status": "आपके लग्न विश्लेषण की स्थिति",
  "processing_your_analysis": "आपका विश्लेषण तैयार किया जा रहा है",
  "analysis_processing_message": "हमारे विशेषज्ञ ज्योतिषी आपकी व्यक्तिगत लग्न राशि विश्लेषण रिपोर्ट पर कार्य कर रहे हैं।"
}
